import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { LayoutModule } from '@angular/cdk/layout';
import { MatSnackBarModule, MatTabsModule, MatProgressBarModule, MatToolbarModule, MatButtonModule, MatSidenavModule, MatIconModule, MatListModule, MatGridListModule, MatCardModule, MatMenuModule, MatTableModule } from '@angular/material';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatBadgeModule} from '@angular/material/badge';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './/app-routing.module';

import { FlexLayoutModule } from '@angular/flex-layout';

import 'hammerjs';

import { InformationComponent } from './header/information/information.component';
import { MenuComponent } from './menu/menu.component';
import { HeaderComponent } from './header/header.component';
import { AboutComponent } from './smartworld/smartworld.component';

import { ProjectsComponent } from './experience/experience.component';
import { NiitComponent } from './experience/niit/niit.component';
import { QadComponent } from './experience/qad/qad.component';
import { MindComponent } from './experience/mind/mind.component';
import { EducationComponent } from './experience/education/education.component';

import { ActivitiesComponent } from './4ir/4ir.component';
import { ArvrComponent } from './4ir/arvr/arvr.component';
import { IotComponent } from './4ir/iot/iot.component';
import { CloudComponent } from './4ir/cloud/cloud.component';
import { ConferencesComponent } from './4ir/conferences/conferences.component';
import { NetworkComponent } from './4ir/network/network.component';



@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    HeaderComponent,
    AboutComponent,
    ProjectsComponent,
    NiitComponent,
    ActivitiesComponent,
    InformationComponent,
    QadComponent,
    MindComponent,
    ArvrComponent,
    IotComponent,
    CloudComponent,
    EducationComponent,
    ConferencesComponent,
    NetworkComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatCheckboxModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatGridListModule,
    MatCardModule,
    MatMenuModule,
    MatProgressBarModule,
    MatTabsModule,
    MatBadgeModule,
    MatExpansionModule,
    MatTableModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    AppRoutingModule,
    FlexLayoutModule,
    MatSnackBarModule
  ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents: [InformationComponent],
})
export class AppModule { }
